import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-gray-lp-800 text-10px italic mb-6" }
const _hoisted_2 = {
  key: 0,
  class: "border border-gray-lp-1400 rounded-lg px-3.5 py-2"
}
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row justify-center items-center gap-2"
}
const _hoisted_4 = {
  key: 0,
  class: "w-28 mr-5"
}
const _hoisted_5 = {
  key: 1,
  class: "w-28"
}
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "flex-grow text-16px text-gray-lp-300" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Title, {
      label: _ctx.$t('clientManagement.managementDetail.bankSettlementInfoTitle')
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.newestUpdated.updatedAt) + " " + _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.by")) + " " + _toDisplayString(_ctx.newestUpdated.updatedByName), 1),
    (!!_ctx.bankDetail.accountName)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (!!_ctx.bankDetail.accountName)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                (!!_ctx.bankDetail.bankName && _ctx.isShowBankLogo)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _createVNode("img", {
                        src: 
            require(`@/app/ui/assets/images/${_ctx.bankDetail.bankName}.png`)
          ,
                        class: "w-28",
                        alt: ""
                      }, null, 8, ["src"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_5)),
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("p", _hoisted_8, _toDisplayString(_ctx.bankDetail.bankLabel), 1),
                    _createVNode("p", _hoisted_9, _toDisplayString(_ctx.bankDetail.accountNo), 1),
                    _createVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("clientManagement.managementDetail.accountNameAbbr")) + " ", 1),
                      _createVNode("span", _hoisted_10, _toDisplayString(_ctx.bankDetail.accountName), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_11, " - "))
  ], 64))
}